import { Resolution } from '@willie/schemas'
import { t } from 'i18next'
import { capitalize } from 'lodash'
import { DateTime } from 'luxon'

export const formatDateLabel = (
  dateStr: string,
  resolution: Resolution,
  locale: string,
  nLabels: number
): string => {
  const dt = DateTime.fromISO(dateStr)
  let dateLabel: string

  switch (resolution) {
    case 'hour':
      dateLabel = dt.toLocaleString(
        {
          month: 'short',
          day: 'numeric',
          hour: '2-digit'
        },
        { locale }
      )
      break
    case 'week':
      dateLabel = `${t('weekOf', { ns: 'common' })} ${dt.toLocaleString({ month: 'short', day: 'numeric' }, { locale })}`
      break
    case 'month':
      dateLabel = dt.toLocaleString({ month: 'long', year: 'numeric' }, { locale })
      break
    case 'day':
    default:
      dateLabel = dt.toLocaleString(
        {
          month: 'short',
          day: 'numeric',
          weekday: nLabels ? 'short' : undefined
        },
        { locale }
      )
      break
  }

  return capitalize(dateLabel)
}
